import { useMemo, useEffect } from "react";
import debounce from "lodash/debounce";
/**
 * useDebouncedCallback - a simple hook to debounce any callback with automatic cleanup.
 *
 * @param callback The function to debounce.
 * @param debounceInterval The debounce delay in milliseconds.
 * @returns A debounced version of the function.
 */ export function useDebouncedCallback(callback, debounceInterval) {
    const debouncedFn = useMemo(()=>debounce(callback, debounceInterval), [
        callback,
        debounceInterval
    ]);
    useEffect(()=>{
        return ()=>{
            debouncedFn.cancel();
        };
    }, [
        debouncedFn
    ]);
    return debouncedFn;
}
